import React from 'react'
import './style.scss'
// import { Icon } from 'react-icons-kit'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'


const Index = ({ totalpage, changePage }) => {
    const location = useLocation()
    const query = queryString.parse(location.search)
    
    return (
        <div className="pageination-items">
            <ul>
                {[...Array(totalpage).keys()].map((i) => {
                    return (
                        <li key={i}>
                            <button
                                type="button"
                                className={parseInt(query.page) === (i + 1) ? "btn shadow-none active" : "btn shadow-none"}
                                onClick={() =>changePage(i + 1)}
                            >{i + 1}</button>
                        </li>
                    )
                })}
            </ul>
        </div>
    );
}

export default Index;